import React from "react"
import styled from "styled-components"
import { appName } from "./domain"

const Heading = styled.div`
    font-size: ${({ theme }) => theme.font.size.xxl};
    display: flex;
    justify-content: space-around;
    margin-top: ${({ theme }) => theme.space.s};
    margin-bottom: ${({ theme }) => theme.space.l};
`

const SubHeading = styled.div`
    font-size: ${({ theme }) => theme.font.size.xl};
    display: flex;
    justify-content: space-around;
    margin-bottom: ${({ theme }) => theme.space.m};
`

export default () => (
    <div>
        <Heading>{appName()} Support Test</Heading>
        <SubHeading>Cloud resource proxy tests</SubHeading>
    </div>
)

export { SubHeading }



// WEBPACK FOOTER //
// ./src/Header.js